import React from "react";
import img from "../../../assets/gps/bike.png";
import img2 from "../../../assets/gps/car.png";
import img3 from "../../../assets/gps/ambulance.png";
import img4 from "../../../assets/gps/jcb.png";
import img5 from "../../../assets/gps/truck.png";
const images = [
  {
    image: img,
  },
  {
    image: img2,
  },
  {
    image: img3,
  },
  {
    image: img4,
  },
  {
    image: img5,
  },
];
const Vehicles = () => {
  return (
    <div className="mx-8 lg:mx-12">
      <div
        className="sm:py-10 py-5  flex justify-center items-center flex-col text-center"
        data-aos="zoom-in-up"
      >
        <h1 className="xl:text-5xl lg:text-3xl text-2xl font-bold tracking-wide text-black sm:pb-5 pb-3 pt-5">
          We almost Track Each & Every Vehicles
        </h1>
        <p className="sm:text-lg text-md font-normal xl:w-[62%] sm:w-[80%] mx-auto text-[#868686] tracking-wide">
          Our GPS technology offers real-time tracking, route optimization,
          geofencing, and location history. Stay connected, monitor movements,
          and enhance security with precision and reliability.
        </p>
      </div>
      <marquee
        width="100%"
        direction="left"
        scrollamount="12"
        behavior="scroll"
      >
        <div className=" py-10 grid md:grid-cols-5 grid-cols-1 gap-5 ">
          {images.map((image, index) => {
            return (
              <div className=" border rounded-2xl border-[#B4B3B3] p-3 flex justify-center items-center ">
                <img src={image.image} className="" />
              </div>
            );
          })}
        </div>
      </marquee>
    </div>
  );
};

export default Vehicles;
